export default __webpack_public_path__ + "static/media/file-excel-svgrepo-com.5d5d791e.svg";